import type { UseLevelTwoResult } from '@/feature-flags/types/variant.types';

type Listener = (state: UseLevelTwoResult) => void;

class LevelTwoEmitter {
  private listeners: Set<Listener> = new Set();
  private currentState: UseLevelTwoResult | null = null;
  private hasLoadedSuccessfully = false;

  subscribe(listener: Listener) {
    this.listeners.add(listener);

    if (this.currentState) {
      listener(this.currentState);
    }
    return () => {
      this.listeners.delete(listener);
    };
  }

  emit(state: UseLevelTwoResult) {
    this.currentState = state;

    if (!state.loading && state.variant) {
      this.hasLoadedSuccessfully = true;
    }

    this.listeners.forEach((listener) => listener(state));
  }

  hasLoaded() {
    return this.hasLoadedSuccessfully;
  }
}

export const levelTwoEmitter = new LevelTwoEmitter();
